import React from "react";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Container from "@material-ui/core/Container";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import { quizContent } from "../quiz/quizData.js";

export default class Quiz extends React.Component {
  opts = ["", 0.0, 0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0];

  extensionQuestion = (obj, i) => {
    if (obj.ext !== undefined)
      return (
        <FormControlLabel
          disabled={
            this.props.domains[this.props.selectedDomain].scores[i * 2] < 4.5
          }
          control={
            <Select
              labelId="label"
              id="select"
              value={
                this.props.domains[this.props.selectedDomain].scores[i * 2 + 1]
              }
              onChange={(e) => this.props.onChange(e, i * 2 + 1)}
            >
              {this.opts.map((x) => {
                return (
                  <MenuItem key={"extopts" + x} value={x}>
                    {x}
                  </MenuItem>
                );
              })}
            </Select>
          }
          label={
            <List>
              <ListItem>
                <ListItemText primary={obj.ext.title} />
              </ListItem>

              {obj.ext.descriptors.map((d, i) => {
                return (
                  <ListItem key={"extdesc" + i}>
                    <ListItemText secondary={d} />
                  </ListItem>
                );
              })}
            </List>
          }
        />
      );
  };

  render() {
    return (
      <Container>
        {quizContent[this.props.selectedDomain][this.props.level].map(
          (obj, i) => {
            return (
              <FormGroup key={"i" + i}>
                <FormControlLabel
                  control={
                    <Select
                      labelId="label"
                      id="select"
                      value={
                        this.props.domains[this.props.selectedDomain].scores[
                          i * 2
                        ]
                      }
                      onChange={(e) => this.props.onChange(e, i * 2)}
                    >
                      {this.opts.map((x) => {
                        return (
                          <MenuItem key={"qopts" + x} value={x}>
                            {x}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  }
                  label={
                    <List>
                      <ListItem>
                        <ListItemText primary={obj.q.title} />
                      </ListItem>

                      {obj.q.descriptors.map((d, i) => {
                        return (
                          <ListItem key={"qdesc" + i}>
                            <ListItemText secondary={d} />
                          </ListItem>
                        );
                      })}
                    </List>
                  }
                />
                {this.extensionQuestion(obj, i)}
              </FormGroup>
            );
          }
        )}
      </Container>
    );
  }
}
